import { render, staticRenderFns } from "./FixedDialog.vue?vue&type=template&id=3c5a7c1d&"
import script from "./FixedDialog.vue?vue&type=script&lang=js&"
export * from "./FixedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports